import React from 'react';
import ReactDOM from 'react-dom';

import LandingSlider from 'components/LandingSlider';

export default (selector) => {
    const landingSlider = document.querySelector(selector);
    if (landingSlider && DJ_CONST.SliderImages && DJ_CONST.SliderImages.length) {
        ReactDOM.render(<LandingSlider slides={DJ_CONST.SliderImages} />, landingSlider);
    }
};



// WEBPACK FOOTER //
// ./src/widgets/LandingSlider.js